// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll(".header__icon--cart"),
  cartIconDesktop: document.querySelector("#cart-icon-desktop"),
  cartIconMobile: document.querySelector("#cart-icon-mobile"),
};
class AjaxCart extends HTMLElement {
  constructor() {
    super();

    this.openeBy = drawerSelectors.cartIcons;
    this.isOpen = this.classList.contains("open--drawer");
    this.bindEvents();
    this.cartNoteInput();
    this.querySelectorAll(".close-ajax--cart").forEach((button) =>
      button.addEventListener("click", this.closeCartDrawer.bind(this))
    );

    if (window.globalVariables.template != "cart") {
      this.addAccessibilityAttributes(this.openeBy);
      this.getCartData();
    } else {
      this.style.visibility = "visible";
      let has_subscription_pr = document.querySelector(
        "[check_subscription]"
      ).value;
      if (has_subscription_pr == "true") {
        this.checkout_btn_click();
      }
    }
    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.removeOnlyFreeGift();
  }

  /**
   * Observe attribute of component
   *
   * @returns {array} Attributes to Observe
   */
  static get observedAttributes() {
    return ["updating"];
  }

  /**
   * To Perform operation when attribute is changed
   * Calls attributeChangedCallback() with params when attribute value is updated
   *
   * @param {string} name attribute name
   * @param {string} oldValue attribute Old value
   * @param {string} newValue attribute latest value
   */
  attributeChangedCallback(name, _oldValue, newValue) {
    // called when one of attributes listed above is modified
    if (name == "updating" && newValue == "false") {
      this.updateEvents();
    }
  }

  /**
   * Add accessibility attributes to Open Drawer buttons
   *
   * @param {Node Array} openDrawerButtons Cart Icons
   */
  addAccessibilityAttributes(openDrawerButtons) {
    let _this = this;
    openDrawerButtons.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", _this.id);
    });
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.querySelector(".close-ajax--cart").dispatchEvent(new Event("click"));
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    if (window.globalVariables.template != "cart") {
      this.openeBy.forEach((cartBtn) =>
        cartBtn.addEventListener("click", this.openCartDrawer.bind(this))
      );
      this.addEventListener("keyup", this.onKeyUp.bind(this));
    }
    this.updateEvents();
  }

  /**
   * bind Other inside element events to DOM
   *
   */
  updateEvents() {
    this.querySelectorAll("[data-itemRemove]").forEach((button) =>
      button.addEventListener("click", this.removeItem.bind(this))
    );
    this.querySelectorAll("[data-qty-btn]").forEach((button) =>
      button.addEventListener("click", this.manageQtyBtn.bind(this))
    );
    this.querySelectorAll("[data-qty-input]").forEach((button) =>
      button.addEventListener("change", this.onQtyChange.bind(this))
    );
  }

  /**
   * Open Cart drawer and add focus to drawer container
   *
   * @param {event} Event instance
   */
  openCartDrawer(event) {
    if (!window.globalVariables.cart_drawer) {
      window.location.href = window.routes.cart_fetch_url || "/cart";
      return;
    }

    if (
      document
        .querySelector("#mobile-menu-drawer")
        .classList.contains("opened-drawer")
    ) {
      document
        .querySelector(".close-mobile--navbar")
        .dispatchEvent(new Event("click"));
    }

    this.classList.add("opened-drawer");
    siteOverlay.prototype.showOverlay();
    Utility.forceFocus(this.querySelector(".cart-title"));
    let closeBtn = this.querySelector(".close-ajax--cart");
    Utility.trapFocus(this, closeBtn);

    if (event) {
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute("aria-expanded", true);
    }
  }

  /**
   * Close Cart drawer and Remove focus from drawer container
   *
   * @param {event} Event instance
   */
  closeCartDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();
      this.classList.remove("opened-drawer");
      siteOverlay.prototype.hideOverlay();
      let openByEle = event.currentTarget;
      openByEle.setAttribute("aria-expanded", false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerSelectors.cartIconDesktop;
      if (window.innerWidth < 1024) {
        actionBtn = drawerSelectors.cartIconMobile;
      }
      Utility.forceFocus(actionBtn);
    }
  }

  /**
   * Update cart HTML and Trigger Open Drawer event
   *
   * @param {string} cartHTML String formatted response from fetch cart.js call
   * @param {string} action Open Drawer as value if need to Open Cart drawer
   */
  _updateCart(response, action) {
    this.setAttribute("updating", true);

    // Convert the HTML string into a document object
    let cartHTML = "";
    cartHTML = response["template-cart"];

    if (cartHTML == null) return;
    let parser = new DOMParser();
    cartHTML = parser.parseFromString(cartHTML, "text/html");
    if (cartHTML.querySelector("[check_subscription]") != null) {
      let has_subscription_pr = cartHTML.querySelector(
        "[check_subscription]"
      ).value;
      let btn_checkout = "";
      if (has_subscription_pr != "true") {
        btn_checkout = document.querySelector(
          "#additional-checkout-buttons"
        ).innerHTML;
        document.querySelector("[additional-checkout-buttons]").style.display =
          "block !important";
      } else {
        document.querySelector("[additional-checkout-buttons]").style.display =
          "none !important";
      }
    }

    let cartJSONEle = cartHTML.querySelector("[data-cartScriptJSON]");
    if (cartJSONEle != undefined && cartJSONEle != null) {
      window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
    }

    let shipping_bar = cartHTML.querySelector("ajax-cart [shipping_bar]");
    let shipping_bar_moblie = cartHTML.querySelector("ajax-cart [free-shipping-element]");

    let cartElement;
    if (window.globalVariables.template == "cart") {
      cartElement = cartHTML.querySelector("ajax-cart [data-cart-form]");
      this.querySelector("[data-cart-form]").innerHTML = cartElement.innerHTML;
    } else {
      cartElement = cartHTML.querySelector("ajax-cart form");
      this.querySelector("form").innerHTML = cartElement.innerHTML;
    }
    if(window.globalVariables.cart.items.length > 0) {
        let isSubscription = false;
        window.globalVariables.cart.items.forEach((item) => {
          if (item.properties["type_of_subscription"]) {
           isSubscription = true;
          }
        });
    if(window.innerWidth < 768){

        if (this.querySelector("[free-shipping-element]") != null && shipping_bar_moblie != null) {
            this.querySelector("[free-shipping-element]").innerHTML = shipping_bar_moblie.innerHTML;
            if (isSubscription) {
              console.log("isSubscription" ,"if", isSubscription);
              this.querySelector("[free-shipping-element]").classList.add("d-none");
            } else {
              console.log("isSubscription" ,"else", isSubscription);
              this.querySelector("[free-shipping-element]").classList.remove("d-none");
            }
        }
      }else{
      if (this.querySelector("[shipping_bar]") != null && shipping_bar != null) {
        this.querySelector("[shipping_bar]").innerHTML = shipping_bar.innerHTML;
        
          if (isSubscription) {
            this.querySelector("[shipping_bar]").classList.add("d-none");
          } else {
            this.querySelector("[shipping_bar]").classList.remove("d-none");
          }
        }
      }
    }
    if (this.querySelector("[data-carttotal] span.money")) {
      this.querySelector("[data-carttotal] span.money").innerHTML =
        Shopify.formatMoney(
          window.globalVariables.cart.total_price,
          window.globalVariables.money_format
        );
    }

    this.manageFreeGift();
    this.removeOnlyFreeGift();

    let elements = this.querySelectorAll(
      "[data-checkoutBtns], [data-complimentary-wrap], [cart_sidebar], [data-cartnote], [data-cartupsell]"
    );
    if (window.globalVariables.cart.item_count <= 0) {
      elements.forEach((div) => {
        div.classList.add("d-none");
      });
      document.querySelector("[data-empty-cart]").classList.remove("d-none");
    } else {
      elements.forEach((div) => {
        div.classList.remove("d-none");
      });
      document.querySelector("[data-empty-cart]").classList.add("d-none");
    }
    this.setAttribute("updating", false);

    let headerHTML = new DOMParser().parseFromString(
      response["header"],
      "text/html"
    );
    let cartIcon = document.getElementById("cart-icon-desktop");
    if (drawerSelectors.cartIconDesktop)
      drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
    if (drawerSelectors.cartIconMobile)
      drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
    document.querySelector(".cart-count").innerHTML =
      window.globalVariables.cart.item_count;

    if (
      window.globalVariables.cart_drawer &&
      action == "open_drawer" &&
      window.globalVariables.template != "cart"
    ) {
      this.openCartDrawer();
    }

    if (window.globalVariables.template == "cart") {
      let has_subscription_pr = cartHTML.querySelector(
        "[check_subscription]"
      ).value;
      if (has_subscription_pr == "true") {
        this.checkout_btn_click();
        document.querySelector("[additional-checkout-buttons]").style.display =
          "none !important";
      } else {
        document.querySelector("[additional-checkout-buttons]").style.display =
          "block !important";
      }
    }
  }

  // manageFreeGift() {
  //   let totalGiftProduct = 0;
  //   window.globalVariables.cart.items.forEach((cartItem) => {
  //     if (cartItem.properties["_isGiftProduct"] == "true") {
  //       totalGiftProduct = totalGiftProduct + 1;
  //       if (cartItem.quantity > 1) {
  //         this._updateFreeGift(cartItem.id, 1);
  //       }
  //     }
  //   });
  // }

  removeOnlyFreeGift (){ 
    if((window.globalVariables.cart.items.length > 0 && window.globalVariables.cart.total_price == 0) && (window.globalVariables.cart.original_total_price != window.globalVariables.cart.total_discount)){      
     this.clearCart();
    }
  }

  manageFreeGift() {
    window.globalVariables.cart.items.forEach((cartItem, key) => {
      if (cartItem.properties["_isGiftProduct"] == "true" || cartItem.properties["_main_product_auto_renew_id"]) {
        const mainProductIndex = window.globalVariables.cart.items.findIndex(
          (item) => item.id == cartItem.properties._main_product_auto_renew_id
        );

        if (mainProductIndex < 0) {
          // removing the free product if it's main product is not in cart
          this._updateFreeGift(key + 1, 0);
        } else if (
          cartItem.quantity !=
          window.globalVariables.cart.items[mainProductIndex].quantity
        ) {
          // else match the quantity of free product with it's main product
          this._updateFreeGift(
            key + 1,
            window.globalVariables.cart.items[mainProductIndex].quantity
          );
        }
      }
    });
  }

  clearCart() {
    fetch(`/cart/clear.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (data) => {
        this.getCartData();
      })
      .catch((e) => {});
  }

  // _updateFreeGift(line, quantity) {
  //   let requestData = {};
  //   requestData[line] = quantity;
  //   const body = JSON.stringify({
  //     updates: requestData,
  //   });

  //   fetch(`/cart/update.js`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: body,
  //   })
  //     .then(async (data) => {
  //       this.getCartData();
  //     })
  //     .catch((e) => {});
  // }

  async _updateFreeGift(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(async (data) => {
        this.getCartData();
      })
      .catch((e) => {});
  }

  /**
   * Fetch latest cart data
   *
   * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
   */
  async getCartData(action) {
    let cartRoute = `${routes.cart_fetch_url}?sections=template-cart,header`;
    await fetch(cartRoute)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this._updateCart(response, action);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Cart HTML fetch done
      });
  }

  _removeFreeProduct() {
    window.globalVariables.cart.items.forEach((i, v) => {
      v = v + 1;
      if (i.properties["_isupsellProduct"] == "true") {
        this.updateItemQty(v, 0);
      }
    });
  }
  /**
   * Update Quantity API call
   *
   * @param {string} line Line Index value of cart Item (Starts from 1)
   * @param {integer} quantity Quantity to update
   */
  updateItemQty(line, quantity, main_prododuct_id) {
    let lineItem = document.querySelectorAll("[data-cart-item]")[line - 1];

    if (lineItem) {
      lineItem.classList.add("updating");
    }
    const body = JSON.stringify({
      line,
      quantity,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((_state) => {
        if (main_prododuct_id) {
          let main_pr =
            document.querySelector(`[main_id="${main_prododuct_id}"]`)?.dataset
              ?.index || null;
          main_pr = main_pr - 1;
          if (main_pr != null) {
            this.updateItemQty(main_pr, 0);
          }
        } else {
          this.getCartData();
        }

        setTimeout(() => {
          if (lineItem) {
            lineItem.classList.remove("updating");
          }
        }, 1000);
      })
      .catch((error) => {
        setTimeout(() => {
          if (lineItem) {
            lineItem.classList.remove("updating");
          }
        }, 1000);
      });
  }

  /**
   * Remove Item Event
   *
   * @param {event} Event instance
   */
  removeItem(event) {
    event.preventDefault();

    let currentTarget = event.currentTarget;
    let main_prododuct_id = currentTarget.getAttribute("varint_id");
    let itemIndex = currentTarget.dataset.index || null;

    if (itemIndex != null) {
      this.updateItemQty(itemIndex, 0, main_prododuct_id);
    }
  }

  /**
   * Cart Item Qunatity Increment/Decrement Button event
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || "increase";
    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    let itemIndex = $qtyInput.dataset.index || 1;
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == "decrease" && currentQty <= 1) {
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }
    this.updateItemQty(itemIndex, finalQty);
  }

  /**
   * Cart Item Qunatity Input change event
   *
   * @param {event} Event instance
   */
  onQtyChange(event) {
    const $qtyInput = event.currentTarget;
    const qtyValue = $qtyInput.value;
    const itemIndex = $qtyInput.dataset.index || null;
    if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
  }

  /**
   * Manage Cart Notes
   */
  cartNoteInput() {
    const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
    if (!cartNoteEle) return;

    const cartNoteSave = document.querySelector("[data-saveNote]");
    let cartNoteEvents = ["input", "paste"];
    cartNoteEvents.forEach((eventName) => {
      cartNoteEle.addEventListener(
        eventName,
        () => {
          const defaultNote = cartNoteEle.dataset.default;
          if (defaultNote != cartNoteEle.value) {
            cartNoteSave.style.display = "block";
          } else {
            cartNoteSave.style.display = "none";
          }
        },
        false
      );
    });

    //  Cart Note Change event
    cartNoteSave.addEventListener("click", (e) => {
      e.preventDefault();
      const currentTarget = e.currentTarget;
      const cartNoteContainer = currentTarget.closest("[data-cartNote]");
      const cartNote = cartNoteContainer
        .querySelector('[name="note"]')
        .value.trim();
      if (cartNote.length <= 0) {
        alert("Add Note before proceeding");
        return;
      }
      const submitBtn = cartNoteContainer.querySelector("[data-saveNote]");
      const waitText = submitBtn.dataset.adding_txt
        ? submitBtn.dataset.adding_txt
        : "Saving...";
      submitBtn.innerHTML = waitText;
      submitBtn.disabled = true;
      this.updateCartNote(cartNoteContainer);
    });
  }

  /**
   * Update Cart Note
   * @param {element} cartNoteContainer
   */
  updateCartNote(cartNoteContainer) {
    const _this = this;
    const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
    const cartNote = cartNoteEle.value.trim();
    const resultEle = cartNoteContainer.querySelector("[data-resultMsg]");
    const submitBtn = cartNoteContainer.querySelector("[data-saveNote]");
    const defaultText = submitBtn.dataset.default
      ? submitBtn.dataset.default
      : "Save";

    let body = JSON.stringify({
      note: cartNote,
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(function (data) {
        if (data.status == 200) {
          if (resultEle) {
            resultEle.innerText = "Added note to Order!";
            _this.manageResponseText(resultEle);
          }
          if (cartNoteEle) {
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = "none";
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        } else {
          console.error("Request returned an error", data);
          if (resultEle) {
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      })
      .catch(function (error) {
        console.error("Request failed", error);
        if (resultEle) {
          resultEle.innerText = error;
          _this.manageResponseText(resultEle);
        }
        submitBtn.innerHTML = defaultText;
        submitBtn.disabled = false;
      });
  }

  /**
   * fade effect on reponse
   * @param {element} element
   */
  manageResponseText(element) {
    Utility.fadeEffect(element, "fadeIn");
    setTimeout(() => {
      Utility.fadeEffect(element, "fadeOut");
    }, 3000);
  }
  checkout_btn_click() {
    document
      .querySelector("[checkout-btn]")
      .addEventListener("click", (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        // var ga_all = ga.getAll()[0].get("linkerParam");
        // var checkout_url = 'https://' + window.globalVariables.recharge_checkout_domain + '/r/checkout?',
        //   url_params = [
        //   'myshopify_domain=' + window.globalVariables.permanent_domain,
        //   ];
        // url_params = url_params
        //   .concat('cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2])
        //   .concat(ga_all);
        // var chk_url = checkout_url + url_params.join('&');
        var chk_url = "/checkout";
        window.location.href = chk_url;
      });
  }
}
customElements.define("ajax-cart", AjaxCart);
